export const ROLE_TYPES_ITEMS = [
    { label: 'Organization Account', name: 'Organization Account', value: 'organization-account' },
    { label: 'Agent', name: 'Agent', value: 'agent' },
    { label: 'CS', name: 'CS', value: 'cs' },
    { label: 'Admins', name: 'Admins', value: 'admins' },
    { label: 'Inventory Broker', value: 'inventory-broker'},
    { label: 'Inventory Admin', value: 'inventory-admin'},
    { label: 'Inventory Agent', value: 'inventory-agent'}
];